module.exports = __webpack_public_path__ + "static/img/BAJIE CHARGING-logo.d26dfa74.png";